import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProductList from './pages/ProductList';
import ProductEdit from './pages/ProductEdit';
import ProductDetail from './pages/ProductDetail';
import BrandList from './pages/BrandList';
import BrandEdit from './pages/BrandEdit';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ProductList />} />
          <Route path="/products/:id/edit" element={<ProductEdit />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/brands" element={<BrandList />} />
          <Route path="/brands/:id" element={<BrandEdit />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
